export default "__VITE_ASSET__8a832a9e__"